import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchLocations } from 'modules/locations/store/actions';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';
import useLocations from './use-locations';

export const useFetchLocation = () => {
  const dispatchWithToast = useDispatchWithToast();
  const tournamentId = useSelector(authStoreUserTournamentId);
  const { isLoading, isLoaded, locations, tournamentId: tournamentIdFromLocations } = useLocations();

  useEffect(() => {
    if (tournamentId && tournamentId !== tournamentIdFromLocations) {
      dispatchWithToast(fetchLocations({ tournamentId }), { error: 'Не удалось загрузить локации' });
    }
  }, [dispatchWithToast, tournamentId, tournamentIdFromLocations]);

  return {
    isLoading,
    isLoaded,
    locations,
  };
};
